/**
 *  @since 0.0.1
 */
export const getApplyConfig = uri => config => (a, r, k) => (config && config[uri] ? config[uri] : (a) => a)(a, r[uri], k);
